export const translations = {
  it: {
    // Header
    title: "Riscaldamento Intelligente GPO",
    subtitle: "Soluzioni di riscaldamento a risparmio energetico per la tua casa",
    switchLang: "RU",

    // Navigation
    products: "Prodotti",
    features: "Caratteristiche",
    contact: "Contatti",

    // Hero Section
    heroTitle: "Riscaldamento Smart per Casa e Business",
    heroSubtitle: "Pannelli radianti in vetro temperato con controllo WiFi. Risparmia fino al 40% sui costi energetici.",
    heroButton: "Chiama Ora",

    // Features
    featuresTitle: "Perché Scegliere GPO?",
    feature1Title: "Controllo WiFi",
    feature1Text: "Gestisci il riscaldamento da qualsiasi luogo tramite smartphone",
    feature2Title: "Risparmio Energetico",
    feature2Text: "Riduzione dei costi energetici del 30-40% rispetto ai riscaldatori tradizionali",
    feature3Title: "Installazione Facile",
    feature3Text: "Montaggio a parete in 20 minuti, senza ristrutturazione",
    feature4Title: "Garanzia 5 Anni",
    feature4Text: "Prodotti di qualità premium con supporto a lungo termine",
    feature5Title: "Sicuro e Silenzioso",
    feature5Text: "Temperatura superficie controllata, funzionamento silenzioso",
    feature6Title: "Design Elegante",
    feature6Text: "Vetro temperato moderno - bianco o nero",

    // Products
    productsTitle: "Catalogo Prodotti",
    productsSubtitle: "Soluzioni complete di riscaldamento per ogni esigenza",

    // Product Categories
    spaceHeaters: "Pannelli Radianti",
    towelDryers: "Scaldasalviette",
    shoeDryers: "Asciugascarpe",

    // Product Details
    power: "Potenza",
    size: "Dimensioni",
    area: "Superficie",
    weight: "Peso",
    wireless: "Connettività",
    materials: "Materiali",
    installation: "Installazione",
    warranty: "Garanzia",
    years: "anni",
    wall: "Parete",
    wallOrFeet: "Parete o Piedini",
    distance: "distanza",
    fullDepth: "profondità totale",

    // Technical Specs
    specsTitle: "Specifiche Tecniche",
    heatingTech: "Tecnologia di Riscaldamento",
    heatingTechDesc: "Riscaldamento a infrarossi + convezione per calore uniforme e rapido",
    glassConstruction: "Costruzione in Vetro",
    glassConstructionDesc: "Due strati di vetro temperato da 3mm con elemento riscaldante da 4mm integrato. Spessore totale 11mm.",
    smartControl: "Controllo Intelligente",
    smartControlDesc: "Display grafico con tastiera, app iOS/Android, controllo cloud incluso a vita",

    // CTA Section
    ctaTitle: "Pronto per il Comfort Intelligente?",
    ctaSubtitle: "Contattaci oggi per una consulenza gratuita e scopri quanto puoi risparmiare",
    ctaButton: "Chiama per Consulenza Gratuita",

    // Delivery Section
    deliveryTitle: "Consegna",
    deliverySubtitle: "Consegna rapida e affidabile in tutta Italia",
    deliveryDescription: "Chiama il nostro manager per discutere i dettagli della tua consegna. Spediremo il tuo ordine entro i prossimi 2 giorni lavorativi.",
    deliveryButton: "Chiama per Organizzare la Consegna",

    // Warranty Section
    warrantyTitle: "Garanzia",
    warrantySubtitle: "5 anni di garanzia completa su tutti i prodotti",
    warrantyTermsTitle: "Termini di Garanzia",
    warrantyTermsText: "Questo Certificato di Garanzia è rilasciato all'acquirente originale dei prodotti sopra menzionati ed è non trasferibile. Il periodo di garanzia si estende per 5 anni dalla data di vendita.",
    warrantyCoverageTitle: "Copertura",
    warrantyCoverageText: "La garanzia copre difetti nei materiali e nella lavorazione in condizioni di uso e servizio normali. La garanzia include la riparazione o sostituzione di parti difettose o dell'intero articolo se il difetto non può essere riparato.",
    warrantyExclusionsTitle: "Esclusioni",
    warrantyExclusions: [
      "Danni derivanti da uso improprio, incidenti, riparazioni non autorizzate o modifiche.",
      "Normale usura.",
      "Danni dovuti a elementi ambientali o naturali.",
      "Uso inappropriato, manipolazione errata, negligenza o funzionamento improprio del prodotto senza seguire le linee guida del manuale utente.",
      "Difetti derivanti da incidenti di trasporto verificatisi al di fuori della responsabilità del produttore.",
      "Danni verificatisi a causa dell'uso al di fuori dei parametri di tensione e frequenza raccomandati.",
      "Danni causati da manutenzione inadeguata del prodotto.",
      "Danni derivanti da interruzioni elettriche, sovratensioni e/o condizioni meteorologiche avverse.",
      "Danni derivanti dalla mancata installazione o assemblaggio del prodotto secondo le istruzioni del manuale utente.",
      "Riparazioni o modifiche effettuate da persone diverse dagli agenti autorizzati.",
      "Deviazioni minori dalla qualità specificata che non influiscono in modo significativo sul valore e sulla funzionalità del prodotto, o deviazioni che un cliente ragionevole si aspetterebbe.",
      "Danni causati da alterazioni nel design, collegamenti elettrici o firmware senza previo accordo con il produttore.",
      "Problemi software e di connettività derivanti da restrizioni locali sull'accesso ai servizi cloud GPO Home.",
      "La copertura della garanzia non si estende all'App o ai tempi di inattività del servizio cloud/online."
    ],
    warrantyClaimsTitle: "Richieste di Garanzia",
    warrantyClaimsText: "Per presentare una richiesta in base a questa garanzia, il cliente deve contattare GPO OÜ. È necessario presentare la prova di acquisto e il prodotto difettoso per richiedere la garanzia.",
    warrantyLiabilityTitle: "Limitazione di Responsabilità",
    warrantyLiabilityText: "GPO OÜ non è responsabile per danni indiretti, accidentali o consequenziali derivanti dall'uso di questi prodotti. GPO OÜ non è responsabile per danni verificatisi durante la consegna.",
    warrantyDate: "Data: 30.09.2025",
    warrantyButton: "Contattaci per Garanzia",

    // Contact
    contactTitle: "I Nostri Uffici",
    scaleaOffice: "Ufficio Scalea",
    riminiOffice: "Ufficio Rimini",
    phone: "Telefono",
    address: "Indirizzo",
    openHours: "Orari",
    weekdays: "Lun-Ven: 9:00-18:00",
    saturday: "Sab: 9:00-13:00",

    // Footer
    footerAbout: "GPO OÜ è specializzata nello sviluppo di soluzioni HVAC ad alta efficienza energetica. Dal 2021 produciamo termostati e dal 2023 riscaldatori, scaldasalviette e dispositivi di automazione domestica.",
    footerCompany: "Azienda",
    footerProducts: "Prodotti",
    footerSupport: "Supporto",
    footerAboutUs: "Chi Siamo",
    footerWarranty: "Garanzia",
    footerShipping: "Spedizione",
    footerContact: "Contatti",
    allRightsReserved: "Tutti i diritti riservati",

    // Product descriptions
    product_G50B: "Pannello radiante compatto nero da 500W, perfetto per spazi 7-10 m². Design elegante in vetro con controllo WiFi e Bluetooth.",
    product_G50W: "Pannello radiante compatto bianco da 500W, ideale per ambienti fino a 10 m². Controllo smart completo.",
    product_G67BV: "Pannello radiante verticale nero da 670W. Montaggio a parete per spazi 7-12 m². Design premium e risparmio energetico.",
    product_G67BH: "Pannello radiante nero da 670W con opzione montaggio a parete o piedini. Versatile e potente.",
    product_G67WV: "Pannello radiante verticale bianco da 670W. Elegante e efficiente per ambienti fino a 12 m².",
    product_G67WH: "Pannello radiante bianco da 670W. Montaggio flessibile a parete o con piedini.",

    product_T50BF1: "Scaldasalviette nero da 500W con 1 barra. Riscalda e asciuga asciugamani mentre riscalda il bagno.",
    product_T50BF2: "Scaldasalviette nero da 500W con 2 barre. Capacità maggiore per più asciugamani.",
    product_T50WF1: "Scaldasalviette bianco da 500W con 1 barra. Design elegante per bagni moderni.",
    product_T50WF2: "Scaldasalviette bianco da 500W con 2 barre. Soluzione completa per il bagno.",

    product_T67BF2: "Scaldasalviette nero da 670W con 2 barre. Maggiore potenza per bagni più grandi.",
    product_T67BF3: "Scaldasalviette nero da 670W con 3 barre. Massima capacità di asciugatura.",
    product_T67WF2: "Scaldasalviette bianco da 670W con 2 barre. Eleganza e potenza combinati.",
    product_T67WF3: "Scaldasalviette bianco da 670W con 3 barre. Soluzione premium per bagni spaziosi.",

    product_S10BF2: "Asciugascarpe nero da 100W. Asciuga fino a 4 paia di scarpe. Perfetto per famiglie attive.",
    product_S10WF2: "Asciugascarpe bianco da 100W. Design discreto e funzionale per l'ingresso.",

    // Material specs
    temperedGlass: "Vetro temperato, acciaio inossidabile",
    wifiBluetooth: "WiFi, Bluetooth"
  },

  ru: {
    // Header
    title: "Дешевое Электрическое Отопление",
    subtitle: "Энергоэффективные решения для отопления вашего дома",
    switchLang: "IT",

    // Navigation
    products: "Продукты",
    features: "Преимущества",
    contact: "Контакты",

    // Hero Section
    heroTitle: "Отопление для Дома и Других Помещений",
    heroSubtitle: "Инфракрасные обогреватели с WiFi управлением. Экономьте до 40% на энергозатратах. Специально для влажного климата.",
    heroButton: "Позвонить Сейчас",

    // Features
    featuresTitle: "Почему Наши Обогреватели?",
    feature1Title: "Энергосбережение",
    feature1Text: "Снижение энергозатрат на 30-40% по сравнению с традиционными электрическими обогревателями.",
    feature2Title: "Безопасно и Тихо",
    feature2Text: "Контролируемая температура поверхности, бесшумная работа, защита от перегрева и влаги.",
    feature3Title: "Автоматизация",
    feature3Text: "Установите таймер или недельный график для оптимального комфорта и экономии. Не требует постоянного вмешательства.",
    feature4Title: "Простая Установка",
    feature4Text: "Монтаж на стену за 10 минут, на пол - 2 минуты. На ножках есть резинки для защиты пола. Легко снимать для хранения летом.",
    feature5Title: "Гарантия 5 Лет",
    feature5Text: "В случае дефекта мы бесплатно заменим или отремонтируем ваш обогреватель. Техническая поддержка на протяжении всего срока службы.",
    feature6Title: "Элегантный Дизайн",
    feature6Text: "Современное закаленное стекло - белое или черное. Тонкий профиль - всего 11мм. Визуально увеличивает пространство за счет отражения света.",
  

    // Products
    productsTitle: "Каталог Продукции",
    productsSubtitle: "Отопления на любой случай - спальни, ванной, прихожей и офиса",

    // Product Categories
    spaceHeaters: "Панельные Обогреватели",
    towelDryers: "Полотенцесушители",
    shoeDryers: "Сушилки для Обуви",

    // Product Details
    power: "Мощность",
    size: "Размеры",
    area: "Площадь",
    weight: "Вес",
    wireless: "Дистанционное Управление",
    materials: "Материалы",
    installation: "Установка",
    warranty: "Гарантия",
    years: "лет",
    wall: "Стена",
    wallOrFeet: "Стена или Ножки",
    distance: "расстояние",
    fullDepth: "полная глубина",

    // Technical Specs
    specsTitle: "Технические Характеристики",
    heatingTech: "Технология Обогрева",
    heatingTechDesc: "Инфракрасный обогрев + конвекция для равномерного и быстрого тепла",
    glassConstruction: "Конструкция из Стекла",
    glassConstructionDesc: "Два слоя закаленного стекла 3мм с интегрированным нагревательным элементом 4мм. Общая толщина 11мм.",
    smartControl: "Удобное Управление",
    smartControlDesc: "Графический дисплей с клавиатурой, приложения iOS/Android, сбор статистики, управление голосом и другие функции",

    // CTA Section
    ctaTitle: "Готовы к Теплу в доме за адекватную цену?",
    ctaSubtitle: "Свяжитесь с нами сегодня для бесплатной консультации и узнайте, сколько вы можете сэкономить",
    ctaButton: "Позвонить для Бесплатной Консультации",

    // Delivery Section
    deliveryTitle: "Доставка",
    deliverySubtitle: "Быстрая и надежная доставка по всей Италии",
    deliveryDescription: "Позвоните нашему менеджеру, чтобы обсудить детали доставки. Мы отправим ваш заказ в течение следующих 2 рабочих дней.",
    deliveryButton: "Позвонить для Организации Доставки",

    // Warranty Section
    warrantyTitle: "Гарантия",
    warrantySubtitle: "5 лет полной гарантии на все продукты",
    warrantyTermsTitle: "Условия Гарантии",
    warrantyTermsText: "Этот Гарантийный сертификат выдается первоначальному покупателю вышеупомянутых продуктов и не подлежит передаче. Гарантийный период составляет 5 лет с даты продажи.",
    warrantyCoverageTitle: "Покрытие",
    warrantyCoverageText: "Гарантия распространяется на дефекты материалов и изготовления при нормальном использовании и обслуживании. Гарантия включает ремонт или замену любых дефектных деталей или всего изделия, если дефект не может быть устранен.",
    warrantyExclusionsTitle: "Исключения",
    warrantyExclusions: [
      "Повреждения в результате неправильного использования, несчастных случаев, несанкционированного ремонта или модификаций.",
      "Нормальный износ.",
      "Повреждения из-за воздействия окружающей среды или природных факторов.",
      "Неправильное использование, неправильное обращение, небрежность или неправильная эксплуатация продукта без соблюдения руководства пользователя.",
      "Дефекты, возникшие в результате транспортных происшествий, произошедших вне ответственности производителя.",
      "Повреждения, возникшие из-за использования за пределами рекомендованных параметров напряжения и частоты.",
      "Повреждения, вызванные ненадлежащим обслуживанием продукта.",
      "Повреждения в результате отключений электроэнергии, скачков напряжения и/или неблагоприятных погодных условий.",
      "Повреждения в результате неправильной установки или сборки продукта согласно инструкциям руководства пользователя.",
      "Ремонт или модификации, проведенные лицами, не являющимися уполномоченными агентами.",
      "Незначительные отклонения от указанного качества, которые существенно не влияют на стоимость и функциональность продукта, или отклонения, которых разумный покупатель мог бы ожидать.",
      "Повреждения, вызванные изменениями в дизайне, электрических соединениях или прошивке без предварительного согласования с производителем.",
      "Проблемы с программным обеспечением и подключением, возникающие из-за местных ограничений на доступ к облачным сервисам GPO Home.",
      "Гарантийное покрытие не распространяется на приложение или время простоя облачных/онлайн-сервисов."
    ],
    warrantyClaimsTitle: "Гарантийные Претензии",
    warrantyClaimsText: "Чтобы предъявить претензию по данной гарантии, клиент должен связаться с GPO OÜ. Для предъявления гарантийной претензии необходимо предоставить доказательство покупки и дефектный продукт.",
    warrantyLiabilityTitle: "Ограничение Ответственности",
    warrantyLiabilityText: "GPO OÜ не несет ответственности за косвенные, случайные или последующие убытки, возникшие в результате использования этих продуктов. GPO OÜ не несет ответственности за повреждения, произошедшие во время доставки.",
    warrantyDate: "Дата: 30.09.2025",
    warrantyButton: "Свяжитесь с Нами по Гарантии",

    // Contact
    contactTitle: "Наши Офисы",
    scaleaOffice: "Офис Скалея",
    riminiOffice: "Офис Римини",
    phone: "Телефон",
    address: "Адрес",
    openHours: "Часы работы",
    weekdays: "Пн-Пт: 9:00-18:00",
    saturday: "Сб: 9:00-13:00",

    // Footer
    footerAbout: "GPO OÜ специализируется на разработке энергоэффективных решений HVAC. С 2021 года мы производим термостаты, а с 2023 года - обогреватели, полотенцесушители и устройства домашней автоматизации.",
    footerCompany: "Компания",
    footerProducts: "Продукты",
    footerSupport: "Поддержка",
    footerAboutUs: "О Нас",
    footerWarranty: "Гарантия",
    footerShipping: "Доставка",
    footerContact: "Контакты",
    allRightsReserved: "Все права защищены",

    // Product descriptions
    product_G50B: "Компактный черный панельный обогреватель 500Вт, идеален для помещений 7-10 м². Элегантный стеклянный дизайн с WiFi и Bluetooth управлением.",
    product_G50W: "Компактный белый панельный обогреватель 500Вт, подходит для помещений до 10 м². Полное умное управление.",
    product_G67BV: "Вертикальный черный панельный обогреватель 670Вт. Настенный монтаж для помещений 7-12 м². Премиум дизайн и энергосбережение.",
    product_G67BH: "Черный панельный обогреватель 670Вт с возможностью монтажа на стену или ножках. Универсальный и мощный.",
    product_G67WV: "Вертикальный белый панельный обогреватель 670Вт. Элегантный и эффективный для помещений до 12 м².",
    product_G67WH: "Белый панельный обогреватель 670Вт. Гибкий монтаж на стену или с ножками.",

    product_T50BF1: "Черный полотенцесушитель 500Вт с 1 перекладиной. Нагревает и сушит полотенца, обогревая ванную.",
    product_T50BF2: "Черный полотенцесушитель 500Вт с 2 перекладинами. Большая вместимость для полотенец.",
    product_T50WF1: "Белый полотенцесушитель 500Вт с 1 перекладиной. Элегантный дизайн для современных ванных.",
    product_T50WF2: "Белый полотенцесушитель 500Вт с 2 перекладинами. Полное решение для ванной.",

    product_T67BF2: "Черный полотенцесушитель 670Вт с 2 перекладинами. Больше мощности для больших ванных.",
    product_T67BF3: "Черный полотенцесушитель 670Вт с 3 перекладинами. Максимальная сушильная способность.",
    product_T67WF2: "Белый полотенцесушитель 670Вт с 2 перекладинами. Элегантность и мощность вместе.",
    product_T67WF3: "Белый полотенцесушитель 670Вт с 3 перекладинами. Премиум решение для просторных ванных.",

    product_S10BF2: "Черная сушилка для обуви 100Вт. Сушит до 4 пар обуви. Идеальна для активных семей.",
    product_S10WF2: "Белая сушилка для обуви 100Вт. Ненавязчивый и функциональный дизайн для прихожей.",

    // Material specs
    temperedGlass: "Закаленное стекло, нержавеющая сталь",
    wifiBluetooth: "WiFi, Bluetooth"
  }
};
